"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MappingTextPack = exports.TMappingTextPack = void 0;
var t = require("io-ts");
//https://lorefnon.tech/2018/03/25/typescript-and-validations-at-runtime-boundaries/
//https://github.com/gcanti/io-ts#typescript-integration
exports.TMappingTextPack = t.type({
    zoomIn: t.string,
    zoomOut: t.string,
    centerMapHere: t.string,
    addAMarker: t.string,
    removeMarker: t.string,
    getGridReference: t.string,
    gridReference: t.string,
    enterAValidGridReference: t.string,
    locateMe: t.string,
    locateMeIsOutsideMapExtent: t.string,
    previousMapExtent: t.string,
    nextMapExtent: t.string,
    mousePosition: t.string,
    downloadPng: t.string,
    permalink: t.string,
    copyToClipboard: t.string,
    toggleFullScreen: t.string,
    attributions: t.string,
    clickOnMapToSelectFeature: t.string,
    clearSelection: t.string,
    goToDetails: t.string,
    centreOnMap: t.string,
    locationPostcode: t.string,
    noResultsFound: t.string,
    zoomToLayer: t.string,
    zoomInToSeeMore: t.string,
    layerNotVisibleAtScale: t.string,
    notAllDataIsVisible: t.string,
    twoFingersPan: t.string,
    ctrlScollToZoom: t.string,
    baseLayers: t.string,
    mainLayer: t.string,
    comparisionLayer: t.string,
    noComparisonLayer: t.string,
    selectFromResults: t.string
});
;
var MappingTextPack = /** @class */ (function () {
    function MappingTextPack() {
    }
    MappingTextPack.load = function () {
        return new Promise(function (resolve, reject) {
            resolve(MappingTextPack.defaults);
        });
    };
    MappingTextPack.defaults = {
        zoomIn: "Zoom in",
        zoomOut: "Zoom out",
        centerMapHere: "Center map here",
        addAMarker: "Add a marker",
        removeMarker: "Remove marker",
        getGridReference: "Get grid reference",
        gridReference: "Grid reference",
        enterAValidGridReference: "Please enter a valid co-ordinate reference,&lt;br/&gt;e.g 485834, 6657359",
        locateMe: "Locate me",
        locateMeIsOutsideMapExtent: "Sorry your location is not in the geographical area covered by this map",
        previousMapExtent: "Previous map extent",
        nextMapExtent: "Next map extent",
        mousePosition: "MousePosition",
        downloadPng: "Download PNG",
        permalink: "Share map",
        copyToClipboard: "Copy to clipboard",
        toggleFullScreen: "Toggle fullscreen",
        attributions: "Attributions",
        clickOnMapToSelectFeature: "Please click on the map to select a feature",
        clearSelection: "Clear selection",
        goToDetails: "Go to details",
        centreOnMap: "Centre on map",
        locationPostcode: "Location, postcode",
        noResultsFound: "No results found",
        zoomToLayer: "Zoom to layer",
        zoomInToSeeMore: "This map layer has reached it's maximum number of records, so not all records are being displayed for this area. Zoom in to see more.",
        layerNotVisibleAtScale: "Layer is not visible at this scale.",
        notAllDataIsVisible: "Not all data is visible at this scale; open the 'Map layers' panel to see details",
        twoFingersPan: "Use two fingers to move the map",
        ctrlScollToZoom: "Use ctrl + scroll to zoom the map",
        baseLayers: "Base layers",
        mainLayer: "Main layer",
        comparisionLayer: "Comparison layer",
        noComparisonLayer: "None",
        selectFromResults: "Please select"
    };
    return MappingTextPack;
}());
exports.MappingTextPack = MappingTextPack;
//# sourceMappingURL=MappingTextPack.js.map